export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_mavericks-pbx/artifacts/9asfwek0_ChatGPT%20Image%20Aug%2011%2C%202026%2C%2006_01_23%20PM.png";

export const COMPANY = {
  name: "Mavericks PBX Solutions",
  phone: "1-888-855-4823",
  phoneRaw: "18888554823",
  whatsapp: "+1 470-452-5359",
  whatsappRaw: "14704525359",
  telegram: "@mavspbxsol",
  telegramUrl: "https://t.me/mavspbxsol",
  email: "info@maverickspbxsolutions.com",
  tagline: "Unified Business Communications",
};

export const FEATURE_OPTIONS = [
  "Auto Attendant / IVR",
  "Voicemail to Email",
  "Call Routing & Forwarding",
  "Extensions & Hunt Groups",
  "Conference Calling",
  "Call Recording",
  "SMS / Text Messaging",
  "Mobile Softphone App",
  "CRM / Helpdesk Integration",
  "International Calling",
  "Reporting & Analytics",
  "E911 Support",
];

export const EMPLOYEE_RANGES = [
  "1 - 10",
  "11 - 50",
  "51 - 100",
  "101 - 250",
  "251 - 500",
  "500+",
];

export const CONTACT_WINDOWS = [
  "Morning (8am - 12pm)",
  "Afternoon (12pm - 4pm)",
  "Late Day (4pm - 6pm)",
  "Anytime",
];

export const STATUS_LABELS = {
  new: "New",
  in_progress: "In Progress",
  contacted: "Contacted",
  closed: "Closed",
};
